export const CompareMany = (a, b) => {
	if (a && b) {
		if (Array.isArray(b)) {
			const tmp_ = b.map((e, i) => {
				return CompareMany(a[i], e);
			});
			return tmp_.filter((x) => x);
		} else if (typeof b === "object") {
			const tmp = {};
			Object.keys(b).forEach((e) => {
				if (e === "startDate" || e === "endDate") {
					let tmp__;
					let tmp___;
					if (typeof b[e] === "string") tmp___ = new Date(b[e]);
					else tmp___ = b[e];
					if (typeof a[e] === "string") tmp__ = new Date(a[e]);
					else tmp__ = a[e];
					if (tmp__.getTime() !== tmp___.getTime()) tmp[e] = b[e];
				} else {
					const tmp_ = CompareMany(a[e], b[e]);
					if (tmp_) tmp[e] = tmp_;
				}
			});
			if (Object.keys(tmp).length === 0) return;
			return tmp;
		} else {
			if (a !== b) {
				return b;
			} else {
				return;
			}
		}
	} else {
		return b;
	}
};
